import { ColumnDef } from "@tanstack/table-core/build/lib/types";
import { CommercialDocument } from "../../graphql/graphql";
import React from "react";

export type InvoicesOrdersTableColumn<T> = ColumnDef<T, any> & {
  accessorKey: keyof T;
  header: string | React.ReactNode | (() => React.ReactNode);
};

export const getInvoicesOrdersTableColumns = (): InvoicesOrdersTableColumn<CommercialDocument>[] => [
    {
        accessorKey: "type",
        header: () => <span>Type</span>,
        cell: ({ row }) => {
            const document = row.original;
            return <span>{document.type}</span>;
        },
    },
    {
        accessorKey: "documentNbr",
        header: () => <span>Document Number</span>,
        cell: ({ row }) => {
            const document = row.original;
            return <span>{document.documentNbr}</span>;
        },
    },
    {
        accessorKey: "declarationAmount",
        header: () => <span>Amount</span>,
        cell: ({ row }) => {
            const document = row.original;
            let formatted;
            if (document.currency && typeof document.currency === 'string' && document.currency.trim().length === 3) {
                formatted = new Intl.NumberFormat('en-US', { style: 'currency', currency: document.currency }).format(document.declarationAmount);
            } else {
                // Fallback: use USD or plain number format if currency is missing/invalid
                formatted = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(document.declarationAmount);
            }
            return <span>{formatted}</span>;
        },
    },
    {
        accessorKey: "status",
        header: () => <span>Status</span>,
        cell: ({ row }) => {
            const document = row.original;
            return <span>{document.status}</span>;
        },
    },
];
